<script setup lang="ts">
// Sizing is left to the call site's Tailwind classes, so no size prop.
interface Props {
  gradient?: boolean;
}

defineProps<Props>();
</script>

<template>
  <div
    class="animate-pulse rounded-sm"
    :class="gradient ? 'bg-linear-to-br from-gray-300 to-gray-200' : 'bg-gray-300'"
  />
</template>
